import {createUseStyles} from "react-jss";
import {colors} from "../../../constants/colors";
import {breakpoints} from "../../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  icon: {},
  filterMenu: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    width: "fit-content",
    display: "flex",
  },
  filters: {
    // margin: "32px 0 24px 0",
    display: "flex",
    justifyContent: "space-between",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      justifyContent: "space-between",
      flexDirection: "column"
    },
  },
  autocomplete: {
    marginRight: "12px",
    minWidth: "auto"
  },
  filterGroups: {
    display: 'flex',
    marginRight: '4px',
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      display: "contents",
    }
  },
  filterContainer: {
    flexDirection: 'row',
    display: "flex",
    justifyContent: "space-between",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      flexDirection: "column"
    }
  },
  filterMenuContainer: {
    flexDirection: 'row',
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    marginLeft: '20px',
    marginTop: 'unset',
    "& input": {
      textOverflow: "ellipsis",
    },
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      marginLeft: 'unset',
      marginTop: '20px',
      justifyContent: "space-between",
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {}
  },
  redemptionFilterElement: {
    marginTop: '16px',
    width: 'fit-content'
  },
  filter: {
    whiteSpace: "nowrap",
    color: colors.grey,
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    width: "fit-content",
    display: "flex",
    alignItems: "center",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: "10px 10px"
    },
    [`@media (min-width: ${breakpoints.sm}px)`]: {
      '&:first-of-type:not(:last-of-type)': {
        borderTopRightRadius: "0",
        borderBottomRightRadius: "0",
        borderRight: 'none'
      },

      '&:last-of-type:not(:first-of-type)': {
        borderTopLeftRadius: "0",
        borderBottomLeftRadius: "0",
      },

      '&:not(:first-of-type):not(:last-of-type)': {
        borderRight: "none",
        borderRadius: "0",
        "&:hover": {
          borderRight: "none"
        },
      }
    },
  },
  active: {
    backgroundColor: colors.brightBlue,
    color: colors.inactiveLightGrey,
    pointerEvents: "none",
    "& svg": {
      "& path": {
        stroke: colors.gray800,
      },
    },
  },
  filterButtons: {
    display: "flex",
    flexDirection: "row",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      display: "grid"
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      display: "flex",
      flexWrap: "wrap",
      gap: "10px",
    },
  },
}));

export default styles;
